<template>
    <div class="l2-more-box pb-12" :style="{ '--l2-more-box-accent': accent } as Record<string, string>">
        <div class="l2-more-box__header">
            <div class="l2-more-box__title">{{ title }}</div>
            <div class="l2-more-box__subtitle">{{ subtitle }}</div>
        </div>

        <div class="l2-more-box__image-frame">
            <img class="l2-more-box__image" :src="imageSrc" :alt="imageAlt" loading="lazy" decoding="async" />
        </div>

        <v-dialog v-model="open" max-width="960" :fullscreen="isMobile">
            <DialogLayout :title="title" card-class="landing-dialog-card" body-class="pa-0" @close="open = false">
                <div class="pa-4">
                    <img class="l2-more-box__full-image" :src="fullImageSrc" :alt="imageAlt" loading="lazy" decoding="async" />
                </div>
            </DialogLayout>
        </v-dialog>
    </div>
</template>

<script lang="ts" setup>
    import DialogLayout from '@/components/global/DialogLayout.vue';
    import { useLandingIsMobile } from '@/pages/Landing/composables/useLandingIsMobile';
    import { ref } from 'vue';

    defineProps<{
        title: string;
        subtitle: string;
        accent: string;
        imageSrc: string;
        fullImageSrc: string;
        imageAlt: string;
    }>();

    const open = ref(false);
    const { isMobile } = useLandingIsMobile();
</script>

<style lang="scss" scoped>
    .l2-more-box {
        position: relative;
        padding: 18px;
        border-radius: 18px;
        border: 1px solid var(--landing-border);
        background:
            radial-gradient(circle at 20% 20%, color-mix(in srgb, var(--l2-more-box-accent) 16%, transparent), transparent 58%),
            radial-gradient(circle at 80% 10%, color-mix(in srgb, var(--l2-more-box-accent) 10%, transparent), transparent 54%), var(--landing-bg);
        box-shadow: 0 14px 30px rgba(15, 23, 42, 0.06);
        overflow: hidden;

        &__header {
            display: grid;
            gap: 6px;
            padding: 2px 2px 0;
            margin-bottom: 14px;
        }

        &__title {
            font-weight: 800;
            font-size: 16px;
            letter-spacing: -0.01em;
            color: var(--landing-text);
        }

        &__subtitle {
            font-size: 14px;
            line-height: 1.55;
            color: var(--landing-muted);
        }

        &__image-btn {
            width: 100%;
            padding: 0;
            border-radius: 16px;
            overflow: hidden;
            border: 1px solid var(--landing-border);
            background: transparent;
            min-height: 0;

            &:focus-visible {
                outline: none;
                box-shadow: 0 0 0 3px color-mix(in srgb, var(--l2-more-box-accent) 45%, transparent);
            }
        }

        &__image-frame {
            width: 100%;
            aspect-ratio: 16 / 9;
            background: var(--l2-bg-elevated);
        }

        &__image {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        &__full-image {
            display: block;
            width: 100%;
            height: auto;
            border-radius: 16px;
        }
    }
</style>
